import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgCaptainDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};
export const SvgCaptain = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_captain)">
      <mask
        id="mask0_captain"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#B90B13"
        />
      </mask>
      <g mask="url(#mask0_captain)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#A036E0"
        />
      </g>
      <path
        d="M10.0921 10.9816C9.70013 11.1272 9.29421 11.2 8.87429 11.2C7.91118 11.2 7.17486 10.9172 6.66533 10.3517C6.16139 9.78061 5.90942 8.99949 5.90942 8.00845C5.90942 7.39812 6.01581 6.85219 6.22858 6.37065C6.44136 5.88351 6.76052 5.49996 7.18606 5.21999C7.61161 4.94003 8.13517 4.80005 8.75669 4.80005C9.14301 4.80005 9.51541 4.87004 9.87373 5.01002L10.0417 6.26146C9.63293 6.06549 9.23541 5.9675 8.84909 5.9675C8.30589 5.9675 7.90558 6.14108 7.64801 6.48824C7.39044 6.82979 7.26166 7.33653 7.26166 8.00845C7.26166 8.67477 7.40724 9.18149 7.6984 9.52869C7.98956 9.87021 8.42909 10.041 9.01701 10.041C9.40901 10.041 9.76733 9.96541 10.0921 9.81421V10.9816Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_captain">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
